import { COMMENT_MIMETYPE_PREFIX } from '../constants';

/**
 * Check if the given search result mimetype matches comment search results
 */
export const isCommentSearchResultMimeType = (mimetype: string) => mimetype.startsWith(COMMENT_MIMETYPE_PREFIX);
